import { NgModule } from '@angular/core';
import { LoginComponent } from './page/login/login.component';
import { EmbeddedLoginFormComponent } from './components/embedded-login-form/embedded-login-form.component';

/**
 * AuthenticationUiModule — backward-compatibility barrel.
 * All components are now standalone. Import them directly in new code.
 * @deprecated Import standalone components directly instead.
 */
@NgModule({
  imports: [LoginComponent, EmbeddedLoginFormComponent],
  exports: [LoginComponent, EmbeddedLoginFormComponent],
})
export class AuthenticationUiModule {}
